import hash from './Hash';
export default hash;
